import { useEffect, useState } from 'react';
import { ThemeProvider } from '@nimbus-ds/styles';
import '@nimbus-ds/styles/dist/index.css';
import { I18nextProvider } from 'react-i18next';
import i18n from './i18n/config';
import LandingPage from './components/LandingPage/LandingPage';
import { Box, Text } from '@nimbus-ds/components';
import { initializeNexo } from './utils/nexo';
import './styles/global.css';

function App() {
  const [nexoStatus, setNexoStatus] = useState<'loading' | 'ready' | 'error'>('loading');

  useEffect(() => {
    initializeNexo()
      .then(() => setNexoStatus('ready'))
      .catch((error) => {
        console.error('Nexo error:', error);
        setNexoStatus('error'); 
      });
  }, []);

  return (
    <I18nextProvider i18n={i18n}>
      <ThemeProvider>
        <Box
          display="flex"
          flexDirection="column"
          backgroundColor="neutral-surface"
          width="100%"
          maxWidth="100%"
          overflowX="hidden"
        >
          <Box
            display="flex"
            alignItems="center"
            justifyContent="center"
            position="relative"
            padding={{ xs: '1', md: '2', lg: '3' }}
            className="app-content"
          >
            {nexoStatus === 'loading' && (
              <Text fontSize="base" color="neutral-textLow">
                Cargando...
              </Text>
            )}
            {nexoStatus === 'ready' && <LandingPage />}
            {nexoStatus === 'error' && (
              <Text fontSize="base" color="danger-textHigh" fontWeight="bold">
                No se pudo cargar la visualización.
              </Text>
            )}
          </Box>
        </Box>
      </ThemeProvider>
    </I18nextProvider>
  );
}

export default App;
